import "./ConfirmSendModal.css";
import "./MessagingButtons.css";

interface ConfirmSendModalProps {
  isOpen: boolean;
  count: number;
  channelLabel: string;
  submitting?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmSendModal = ({
  isOpen,
  count,
  channelLabel,
  submitting = false,
  onCancel,
  onConfirm,
}: ConfirmSendModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="msg-confirm-overlay" role="dialog" aria-modal="true">
      <div className="msg-confirm">
        <div className="msg-confirm__header">
          <h3>Send to {count} client{count === 1 ? "" : "s"}?</h3>
          <button
            className="msg-confirm__close"
            onClick={onCancel}
            aria-label="Close"
            disabled={submitting}
          >
            ×
          </button>
        </div>
        <p className="msg-confirm__body">
          This will send a <strong>{channelLabel}</strong> message to{" "}
          <strong>{count}</strong> selected client{count === 1 ? "" : "s"}.
          {count > 1 &&
            " More than one recipient is sent through a message campaign."}{" "}
          Recipients will be marked as <strong>Sent</strong> (message prepared
          for delivery).
        </p>
        <div className="msg-confirm__actions">
          <button
            className="msg-btn msg-btn--secondary"
            onClick={onCancel}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            className="msg-btn msg-btn--primary"
            onClick={onConfirm}
            disabled={submitting}
          >
            {submitting ? "Sending…" : "Confirm send"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmSendModal;